import { useTranslation } from 'react-i18next'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../../constants/validation'
import { useTimeZone } from '../../../../../../hooks'
import { EntityEditFormModal } from '../../../../../Entity'

import { QA_NAME_LISTING_PUBLICATION_SCHEDULE_MODAL } from './ListingPublicationScheduleModal.constants'
import {
  getListingPublicationScheduleErrorKey,
  getListingPublicationScheduleInitialValues,
  getListingPublicationSchedulePayload,
  getListingPublicationScheduleValidationSchema,
} from './ListingPublicationScheduleModal.utils'
import { ListingPublicationScheduleModalFields } from './ListingPublicationScheduleModalFields'

function ListingPublicationScheduleModal({
  bounds,
  initialValue,
  labelKey,
  titleKey,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  const initialValues = getListingPublicationScheduleInitialValues({
    timezone,
    value: initialValue,
  })

  async function handleSubmit({ payload, setErrors, setSubmitting }) {
    return onSubmit(payload).catch(error => {
      setSubmitting(false)

      setErrors({
        [SERVER_NON_FIELD_ERROR_KEY]: t(
          getListingPublicationScheduleErrorKey(error)
        ),
      })
    })
  }

  return (
    <EntityEditFormModal
      Fields={ListingPublicationScheduleModalFields}
      formFieldsProps={{ bounds, labelKey }}
      formTitle={titleKey}
      getPayload={getListingPublicationSchedulePayload}
      initialValues={initialValues}
      qaName={QA_NAME_LISTING_PUBLICATION_SCHEDULE_MODAL}
      validationSchema={getListingPublicationScheduleValidationSchema({
        bounds,
        initialValues,
        t,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ListingPublicationScheduleModal
